<div class="mobile-list">

    @for (car of cars; track car.id) {
    <button type="button" class="mobile-item" (click)="carClick.emit(car)" (keydown.enter)="carClick.emit(car)">

        <!-- Top row: ID + Status -->
        <div class="item-top">
            <span class="item-id">#{{ car.id }}</span>
            <span class="item-status" [style.background]="getStatusStyle(car.status).background"
                [style.color]="getStatusStyle(car.status).color">
                <span class="status-dot" [style.background]="getStatusStyle(car.status).color"></span>
                {{ car.status.replace('_', ' ') | titlecase }}
            </span>
        </div>

        <!-- Middle row: image + plate/model + fuel + battery -->
        <div class="item-middle">
            <div class="item-car">
                <div class="item-img">
                    <img [src]="car.imageUrl" alt="car"
                        (error)="$any($event.target).src='assets/icons/car-placeholder.svg'" />
                </div>
                <div class="item-info">
                    <span class="item-plate">{{ car.plateNo }}</span>
                    <span class="item-model">{{ car.model.maker }} {{ car.model.name }}</span>
                </div>
            </div>

            <div class="item-metrics">
                <div class="metric">
                    <img src="assets/icons/fuel-icon.svg" alt="fuel" class="metric-icon"
                        (error)="$any($event.target).style.display='none'" />
                    <div class="metric-info">
                        <span class="metric-label">FUEL</span>
                        <span class="metric-value">{{ getFuelPct(car).toFixed(0) }}%</span>
                    </div>
                </div>
                <div class="metric">
                    <img src="assets/icons/battery-icon.svg" alt="battery" class="metric-icon"
                        (error)="$any($event.target).style.display='none'" />
                    <div class="metric-info">
                        <span class="metric-label">BATTERY</span>
                        <span class="metric-value">{{ getBatteryPct(car).toFixed(0) }}%</span>
                    </div>
                </div>
            </div>
        </div>

        <!-- Bottom row: rides + last ride + last update + location -->
        <div class="item-bottom">
            <span class="item-stat"><span class="stat-label">RIDES:</span> {{ car.totalRides }}</span>
            <span class="item-stat"><span class="stat-label">LAST RIDE:</span> {{ timeAgo(car.lastRideAt) }}</span>
            <span class="item-stat"><span class="stat-label">LAST UPDATE:</span> {{ timeAgo(getLastUpdate(car)) }}</span>
            <button class="location-btn" (click)="openMaps(car); $event.stopPropagation()">
                <img src="assets/icons/location-arrow.svg" alt="location" />
            </button>
        </div>

    </button>
    }

    @if (cars.length === 0) {
    <div class="no-data">No vehicles found</div>
    }

</div>

@if (cars.length > 0) {
<div class="mobile-footer">
    <span class="footer-count">Showing {{ first + cars.length }} of {{ totalRecords }}</span>
    <p-paginator [first]="first" [rows]="rows" [totalRecords]="totalRecords" [rowsPerPageOptions]="[20, 30, 50]"
        (onPageChange)="pageChange.emit($event)" />
</div>
}